import React from 'react';
import PropTypes from 'prop-types';
import { 
  HeroMain,
  MainBox,
  HeroTitle,
  HeroImage,
  HeroSubTitle,
  LogoContainer,
  HeroSubTitleContainer
} from './index.style'
import RichText from '@components/RichText';
import { GatsbyImage } from 'gatsby-plugin-image';
import Logo from '@svgs/Logo';
import { Heading4Sans, Heading4Serif } from '@components/TextStyles';
import { colors } from '@styles/vars/colors.style'
import Container from '@components/Container';
import Spacer from '@components/Spacer';

const Hero = props => {
  const { backgroundColor, textColor, title, image } = props;

  const background = backgroundColor ? backgroundColor : colors.charcoal;
  const color = textColor ? textColor : colors.white;
  return (
    <HeroMain color={color} background={background}>
      <Container>
        <MainBox>
          <HeroTitle>
            {title && <RichText content={title} as="h1" />}
          </HeroTitle>
          <HeroImage>
            <GatsbyImage image={image.gatsbyImageData} alt={image.description} height="526" width="526" />
          </HeroImage>
        </MainBox>
      </Container>
    </HeroMain>
  );
};

Hero.propTypes = {
  imageimage: PropTypes.array,
  title: PropTypes.object,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default Hero;